import { useReducer } from "react";

const initialState = {
	updateFile: false,
	addTraining: false,
	exportCsv: false,
	addSubject: false,
	addResults: false,
	addStudents: false,
};

const reducer = (state, action) => {
	switch (action.type) {
		case "toggleUpdateFile":
			return { ...state, updateFile: !state.updateFile };
		case "toggleAddTraining":
			return { ...state, addTraining: !state.addTraining };
		case "toggleExportCsv":
			return { ...state, exportCsv: !state.exportCsv };
		case "toggleAddSubject":
			return { ...state, addSubject: !state.addSubject };
		case "toggleAddResults":
			return { ...state, addResults: !state.addResults };
		case "toggleAddStudents":
			return { ...state, addStudents: !state.addStudents };
		default:
			return state;
	}
};

const useHelpButtonReducer = () => {
	const [state, dispatch] = useReducer(reducer, initialState);

	const setTrainingModal = () => dispatch({ type: "toggleAddTraining" });

	const setUpdateFileModal = () => dispatch({ type: "toggleUpdateFile" });

	const setCsvModal = () => dispatch({ type: "toggleExportCsv" });

	const setSubjectModal = () => dispatch({ type: "toggleAddSubject" });

	const setResultModal = () => dispatch({ type: "toggleAddResults" });

	const setAddStudentModal = () => dispatch({ type: "toggleAddStudents" });

	return {
		state,
		setTrainingModal,
		setUpdateFileModal,
		setCsvModal,
		setSubjectModal,
		setResultModal,
		setAddStudentModal,
	};
};

export default useHelpButtonReducer;
